import { RouteObject } from "react-router-dom";
import { CampaignLogin } from "./auth/campaign-login";
import { CampaignVerify } from "./auth/campaign-verify";
import { Login } from "./auth/login";
import { Verify } from "./auth/verify";
import {
  CheckoutCancelContainer,
  CheckoutContainer,
  CheckoutSuccess,
} from "./components";
import { MarketplaceLayout } from "./layouts";
import { BrandBulkPurchase, BrandListing, BrandsLayout } from "./marketplace";
import { MarketplaceHome } from "./marketplace-home";
import { ProductDetailPage } from "./product-detail-page";
import { RouterRoot } from "./root";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <RouterRoot />,
    children: [
      { path: "login", element: <Login /> },
      { path: "auth/verify", element: <Verify /> },
      { path: ":campaignSlug", element: <CampaignLogin /> },
      { path: ":campaignSlug/verify", element: <CampaignVerify /> },
      {
        path: "/",
        element: <MarketplaceLayout />,
        children: [
          { index: true, element: <MarketplaceHome /> },
          { path: "product/:productId", element: <ProductDetailPage /> },
          { path: "stores/:teamId/*", element: <MarketplaceHome /> },
          {
            path: "brands",
            element: <BrandsLayout />,
            handle: { breadcrumb: "Brands" },
            children: [
              { index: true, element: <BrandListing /> },
              {
                path: ":brandId",
                element: <BrandBulkPurchase />,
                handle: { breadcrumb: "Brand details" },
              },
            ],
          },
          { path: "checkout", element: <CheckoutContainer /> },
          { path: "checkout/success", element: <CheckoutSuccess /> },
          { path: "checkout/cancel", element: <CheckoutCancelContainer /> },
        ],
      },
    ],
  },
];
